var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Crehana = function Crehana(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      d: "M9.29248 3.85718H3.29248V9.85718H9.29248V15.8572H3.29248V21.8572H9.29248V15.8572H15.2925V21.8572H21.2925V15.8572V9.85718V3.85718H15.2925V9.85718H9.29248V3.85718Z"
    }))
  });
};
export default Crehana;